export default {
  invoice_no: '单据号',
  click_to_upload_image_for_your_logo: '点击上传你的logo',
  edit_form_welcome_description: '编辑欢迎语',
  page_no: '页面编号',
  page_link: '页面链接',
  page_qr: '页面二维码',
  scan_open_payment_page: '扫码进入payment page',
  create_new_link: '创建新链接',
  create_new_page: '创建新链接',
  transaction_amount: '交易金额',
  total_transaction_amount: '总交易金额',
  total_quantity: '总笔数'
}
